"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _All = _interopRequireDefault(require("./All"));

var _New = _interopRequireDefault(require("./New"));

var parent = function parent(_ref) {
  var match = _ref.match;
  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
    exact: true,
    from: "".concat(match.url),
    to: "".concat(match.url, "/allparent")
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/allparent"),
    component: _All.default
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "".concat(match.url, "/requests"),
    component: _New.default
  }));
};

var _default = parent;
exports.default = _default;